import { headerStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

headerStyles.container = {
    ...headerStyles.container,

    gap: 20,

    css: css`
        padding: 0;
        margin-bottom: 20px;

        ${mediaQueriesBP.minMD} {
            margin-bottom: 40px;
        }
    `,
};

headerStyles.rightTopGridItem = {
    ...headerStyles.rightTopGridItem,

    css: css`
        ${mediaQueriesBP.minMD} {
            &&& {
                margin-bottom: 20px;
            }
        }
    `,
};

headerStyles.leftTopGridItem = {
    ...headerStyles.leftTopGridItem,

    css: css`
        ${TypographyStyle} {
            font-size: 26px;
            font-weight: 500;
            line-height: normal;
            margin: 0;

            ${mediaQueriesBP.minMD} {
                font-size: 36px;
            }
        }
    `,
};
